

































import Vue from 'vue'
import './LeftSidebar.scss'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'

export default Vue.extend({
  name: 'LeftSidebar',
  props: {
    menuItems: {
      type: Array,
      required: true
    },
    adminMenuItems: {
      type: Array,
      required: true
    }
  },
  computed: {
    doOps (): boolean {
      return this.$can(AbilityAction.Do, AbilitySubject.Ops)
    },
    tosUrl (): string {
      return this.$store.direct.state.admin.legalinfo.tosUrl
    },
    privacyUrl (): string {
      return this.$store.direct.state.admin.legalinfo.privacyUrl
    },
    year (): number {
      const date = new Date()
      return date.getFullYear()
    }
  }
})
